import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { Subscription } from 'rxjs';
import { ValidationError } from '../../../../domain/error.model';
import { ErrorAwareComponent, LsnErrorStateMatcher } from '../../../shared/middleware/error-state-matcher';
import { ErrorsState } from '../../store/errors.state';
import { UserAction } from '../../store/user.action';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit, OnDestroy, ErrorAwareComponent {

    subscriptions: Subscription[] = [];
    errors: ValidationError[] = [];

    username = '';
    matchers = {
        username: new LsnErrorStateMatcher(this, 'username')
    };

    constructor(private store: Store) {
    }

    ngOnInit(): void {
        this.subscriptions.push(
            this.store.select(ErrorsState.getMainErrors).subscribe(errors => this.errors = errors)
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    submit() {
        this.store.dispatch(new UserAction.ForgotPassword(this.username));
    }

}
